<template>
  <div class="customer-review">
    <index-view title="Báo cáo hình ảnh" :filters="filters" :getData="getData" :headers="mainHeaders" :monthDisabled="true" :fromTo="true" 
      :cellSlots="cellSlots"
    >
      <template #viewSection="{ item }">
        <detail :item="item"></detail>
      </template>

      <template v-slot:[`attachmentUrl`]="{ cell }">
      <img v-for="url in urlToImageArr(cell.attachmentUrl)" :src="url" @click="viewer = true, viewerUrl = url">
        <img v-for="url in urlToImageArr(cell.attachmentUrl)" :key="url" :src="url" width="150px" @click="viewer = true, viewerUrl = url">
        </img>
      </template>
      <template v-slot:[`status`]="{ cell }">
        <span v-if="cell.status==0">Tạo mới</span>
        <span v-if="cell.status==1">Xác nhận</span>
      </template>
    </index-view>

    <v-dialog class="rounded-xl" v-model="viewer" width="1200">
      <v-card class="rounded-xl">
        <v-card-title>
          Hình ảnh
        </v-card-title>
        <v-img :src="viewerUrl" height="80vh" contain></v-img>
      </v-card>
    
    </v-dialog>
  </div>
</template>

<script>

import IndexView from '@/components/CommonView/IndexView.vue';
import { get } from './api'
import { main } from './header'
import Detail from './Detail.vue'
export default {
  name: "CustomerReview",
  components: {
    IndexView,
    Detail
  },
  computed: {
    mainHeaders () {
      return main(this.filters)
    }
  },
  data() {
    return {
      viewer: false,
      viewerUrl: null,
      cellSlots: ['attachmentUrl', 'status'],
      filters: [
        {name: 'id', label:'Id', type: 'text', value: '' },
        {name: 'name', label:'Tên báo cáo', type: 'text', value: '' },
        {name: 'rm', label:'RM', type: 'text', value: '' },
        {name: 'am', label:'AM', type: 'text', value: '' },
      ],
      // mainData: []
    }
  },
  methods: {
    getData: get,
    urlToImageArr(urls) {
      if(!urls) return []
      var arr = urls.split(';')
      return arr
    }
  }
}
</script>